import React from 'react'
import {withRouter} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import MuiTooltip from '@material-ui/core/Tooltip'
import MuiIconButton from '@material-ui/core/IconButton'
import CreateIcon from '@material-ui/icons/Create'
import {useCurrentUser} from 'users/hooks'
import {useMode} from 'app/hooks'
import {resetEditState} from 'lms/store/actions'

const EditButton = ({lms, history, staticContext, ...props}) => {
  const [mode] = useMode()
  const user = useCurrentUser()
  const dispatch = useDispatch()

  // Only extract admins here, we'll get the ID when needed
  const {admins} = lms

  switch (mode) {
    case 'user':
      return null
					
    case 'User':
      return null

    case 'vendor':
      if (!admins || !admins.includes(user.id)) return null

    // no default
  }

  const buttonIcon = <CreateIcon/>
  const tooltipText = "Edit System"

  const handleClick = (event) => {
    event.stopPropagation()
    
    // Use either id or _id depending on what's available
    const applicationId = lms.id || lms._id
    
    if (!applicationId) {
      console.error('No valid ID found for application', lms)
      return
    }
    
    // Reset the edit state before navigating to ensure no stale data
    dispatch(resetEditState())
    
    // Navigate to the edit page
    history.push(`/systems/${applicationId}/edit`)
  }

  return (
    <MuiTooltip title={tooltipText}>
      <MuiIconButton
        color="secondary"
        onClick={handleClick}
        {...props}
      >
        {buttonIcon}
      </MuiIconButton>
    </MuiTooltip>
  )
}

export default withRouter(EditButton)
